<template lang="pug">
AppDialog.vue-time-entries-notes-dialog(
  :title="header"
  append-to-body
  :show="show"
  @close="close"
)
  .notes(
    v-for="{ timeEntry, notes } in timeEntriesWithNotes"
    :key="timeEntry.id"
  )
    .meta
      .project-name
        span.strong
          | {{ projectTaskName(timeEntry) }}
        span.time.text-lighter.ml-5
          | {{ formattedTimeRange(timeEntry) }}
    .note(
      v-for="(note, index) in notes"
      :key="`${note.description}-${index}`"
    )
      p
        | {{ $filters.stripHTML(note.description) }}
  template(#footer)
    button.btn.btn-default(@click="close") Close
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, find } from 'lodash-es';

export default {
  name: 'TimeEntriesNotesDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    date: {
      type: Object,
      required: true,
    },
    timeEntries: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['user', 'projects', 'tasks', 'notesForTimeEntry']),
    header() {
      return `${this.user.name}'s notes for ${TimeUtils.format_date(this.date)}`;
    },
    timeEntriesWithNotes() {
      return this.timeEntries
        .map((te) => {
          return {
            timeEntry: te,
            notes: this.notesForTimeEntry(te),
          };
        })
        .filter((e) => !isEmpty(e.notes));
    },
  },
  methods: {
    formattedTimeRange(timeEntry) {
      const startTime = TimeUtils.parse_internal_datetime(timeEntry.start_time);
      const stopTime = TimeUtils.parse_internal_datetime(timeEntry.stop_time);

      return `${TimeUtils.format_time(startTime, false)} - ${TimeUtils.format_time(stopTime, false)}`;
    },
    projectTaskName(timeEntry) {
      const project = find(this.projects, { id: timeEntry.project_id });
      const projectName = project.text;
      const task = find(this.tasks, { id: timeEntry.task_id });

      return task ? `${projectName} / ${task.text}` : projectName;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
